<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addDataParkHonor" v-if="permissionCodes.indexOf('033003001') !== -1"/>
        <!--<button-delete @deleteSelection="deleteSelection" />-->
      </div>
      <input-select selectTitle="设备类型" :selectKey="'deviceType'" selectWidth="180px" :selectData="deviceTypeList" @search="search" style="margin-right: 10px;"/>
      <input-search placeholder="设备名称/设备编号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @deleteLine="deleteLine" :deleteTipInfo="'是否确认删除该数据？'" @goToModifyPage="goToModifyPage" @changeSelection="changeSelection" :total="total" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" :operationArr="operationArr" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/SmartDetection";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "smart-detection-gateway-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "配电监测",
          name: "smart-detection-over-view"
        },
        {
          value: "网关设备"
        }
      ],
      addDataParkHonor: "smart-detection-gateway-add",
      operationArr: ["modify", "delete"],

      deviceTypeList: [
        {key: "", label: "全部" },
        {key: '液位网关', label: '液位网关'},
        {key: '液压网关', label: '液压网关'},
        {key: '温湿度网关', label: '温湿度网关'},
        {key: '水浸网关', label: '水浸网关'},
        {key: '气体监测网关', label: '气体监测网关'},
        {key: '水质网关', label: '水质网关'},
        {key: '电流/电流网关', label: '电流/电流网关'},
        {key: '泵监测网关', label: '泵监测网关'},
        {key: '风速网关', label: '风速网关'},
        {key: '气压网关', label: '气压网关'},
        {key: '高度网关', label: '高度网关'},
      ],

      tableHead: [
        {
          prop: "deviceName",
          label: "设备名称"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "deviceType",
          label: "设备类型"
        },
        {
          prop: "deviceStatus",
          isStatus: true,
          label: "设备状态"
        },
        {
          prop: "deviceManufacturerName",
          label: "设备厂商"
        },
        {
          prop: "deviceModelName",
          label: "设备型号"
        },
        // {
        //   prop: "powerRoomName",
        //   label: "所属场所"
        // },
        {
          prop: "responsiblePersonName",
          label: "责任人"
        }
      ],
      tableData: [],
      total: 0,
      selectionArr: [],
      requestData: {
        deviceType: '',
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      dialogFormVisible: false,
      videoInfo: {}
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      this.$axios
        .post(api.getEnvironmentGatewayPage, this.requestData)
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.code = v.deviceCode;
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取数据失败"));
    },
    search(v) {
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    goToModifyPage(code) {
      this.$router.push({
        path: "/smart_detection_gateway_modify/" + code
      });
    },

    deleteLine(code) {
      this.$axios
        .post(api.deleteEnvironmentGatewayByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    }
  },
  watch: {
    centEndTime(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.form-line {
  width: 420px;
  margin: 20px auto;
  display: flex;
  justify-content: flex-start;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.red {
  color: red;
}
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionGatewayManage/SmartDetectionGatewayManage.vue